/**
 * PR-09: Utilitaire pour calculer les bounds de sélection multi-select
 */
import type { ShapeData } from '../types/ShapeTypes';

function getDefaultWH(shape: ShapeData) {
  switch (shape.type) {
    case 'text':
      return { w: 220, h: 60 };
    case 'image':
      return { w: 200, h: 150 };
    case 'circle':
      return { w: 100, h: 100 };
    case 'line':
      return { w: 120, h: 6 };
    case 'arrow':
      return { w: 120, h: 40 };
    case 'photoSpace':
      return { w: 240, h: 180 };
    default:
      return { w: 120, h: 80 };
  }
}

/**
 * Calcule les bounds de sélection pour plusieurs shapes
 * @param shapes Toutes les shapes disponibles
 * @param ids IDs des shapes sélectionnées
 * @returns Bounds de la sélection ou null si aucune sélection
 */
export function computeSelectionBounds(shapes: ShapeData[], ids: string[]) {
  const selected = shapes.filter(s => ids.includes(s.id));
  if (selected.length === 0) return null;

  let minX = Infinity,
    minY = Infinity,
    maxX = -Infinity,
    maxY = -Infinity;

  for (const s of selected) {
    const { w, h } = getDefaultWH(s);
    const width = s.width ?? w;
    const height = s.height ?? h;

    minX = Math.min(minX, s.x);
    minY = Math.min(minY, s.y);
    maxX = Math.max(maxX, s.x + width);
    maxY = Math.max(maxY, s.y + height);
  }

  const width = maxX - minX;
  const height = maxY - minY;

  return {
    x: minX + width / 2, // ✅ centre X (pour translateX(-50%))
    y: minY,
    width,
    height,
  };
}
